import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// routes
import Router from './router';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeProvider >
      <HelmetProvider>
        <BrowserRouter>
          <ToastContainer theme="colored" autoClose={5000} />
          <ScrollToTop />
          <StyledChart />
          <Router />
        </BrowserRouter>
      </HelmetProvider>
    </ThemeProvider>
  );
}
